import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  // Main Title
  BigTitle: {
    position: "relative",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "5px 0 10px",
    [theme.breakpoints.up("xs")]: {
      fontSize: "3rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "5rem",
    },
    fontWeight: "800",
    color: theme.palette.light.overlay,
  },
  SmallTitle: {
    position: "absolute",
    top: "80%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontSize: "1.5rem",
    color: theme.palette.light.main,
    fontWeight: "500",
  },
  afterClass: {
    position: "absolute",
    bottom: "2px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "50%",
    height: "2px",
    backgroundColor: theme.palette.primary.main,
  },
  // Profile Image
  media: {
    width: 200,
    height: 250,
    [theme.breakpoints.up("sm")]: {
      width: 220,
      height: 300,
    },
    [theme.breakpoints.up("lg")]: {
      width: 340,
      height: 400,
    },
  },
  aboutBox: {
    borderBottom: `1px solid ${theme.palette.grey.dark}`,
    padding: "8px 0px",
  },
  progressBar: {
    position: "relative",
    width: "100%",
    height: "7px",
    borderRadius: "10px",
    backgroundColor: theme.palette.grey.dark,
  },
  bar: {
    position: "absolute",
    top: "0",
    left: "0",
    height: "100%",
    borderRadius: "10px",
    backgroundColor: theme.palette.primary.main,
  },
  tabsStyled: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "30px",
    alignItems: "center",
    flexWrap: "wrap",
    margin: "0 0 30px 0",
    [theme.breakpoints.up("xs")]: {
      margin: "50px 20px 40px",
    },
  },
  textField: {
    width: "100%",
    marginBottom: "10px !important",
  },
  submitButton: {
    marginBottom: "30px",
    width: "100%",
  },
}));

export default useStyles;
